/**
 * Calculates duration between two times in "HH:MM AM/PM" format
 * @param {string} startTime - Format "HH:MM AM/PM" (e.g., "09:30 AM")
 * @param {string} endTime - Format "HH:MM AM/PM" (e.g., "09:50 AM")
 * @returns {string} Duration in minutes (e.g., "20")
 */
export function calculateDuration(startTime, endTime) {
  if (
    !startTime ||
    !endTime ||
    typeof startTime !== "string" ||
    typeof endTime !== "string"
  ) {
    return "0";
  }

  const timeToMinutes = (timeStr) => {
    const [time, period] = timeStr.trim().split(" ");
    if (!time || !period) return 0;

    const timeParts = time.split(":");
    const hours = parseInt(timeParts[0], 10);
    const minutes = timeParts[1] ? parseInt(timeParts[1], 10) : 0; // Default to 0 minutes

    if (isNaN(hours) || isNaN(minutes)) return 0;

    let hours24 = hours;
    if (period.toUpperCase() === "PM" && hours !== 12) {
      hours24 += 12;
    } else if (period.toUpperCase() === "AM" && hours === 12) {
      hours24 = 0;
    }

    return hours24 * 60 + minutes;
  };

  const startMins = timeToMinutes(startTime);
  const endMins = timeToMinutes(endTime);

  if (isNaN(startMins) || isNaN(endMins)) {
    return "0";
  }

  let diffMins;
  if (endMins >= startMins) {
    diffMins = endMins - startMins;
  } else {
    diffMins = 24 * 60 - startMins + endMins;
  }

  return Math.max(0, diffMins).toString();
}
